import React, { useRef, useEffect, useState } from 'react';
import { Box, TextField, MenuItem } from '@material-ui/core';
import { useStyles } from './style';

interface LogEntry {
  timestamp: string;
  level: string;
  action: string;
  details?: string;
  user?: string;
}

interface TestLogViewerProps {
  logs: LogEntry[];
}

const TestLogViewer: React.FC<TestLogViewerProps> = ({ logs }) => {
  const classes = useStyles();
  const scrollRef = useRef<HTMLDivElement>(null);
  const [filter, setFilter] = useState<string>('all');

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [logs]);

  const filteredLogs = filter === 'all' ? logs : logs.filter((l) => l.level === filter);

  const getLevelClass = (level: string) => {
    const map: Record<string, string> = {
      info: classes.logInfo,
      warn: classes.logWarn,
      error: classes.logError,
      debug: classes.logDebug,
    };
    return map[level] || '';
  };

  const formatTimestamp = (ts: string) => {
    try {
      return new Date(ts).toLocaleTimeString();
    } catch {
      return ts;
    }
  };

  return (
    <Box>
      <Box mb={1}>
        <TextField
          select
          size="small"
          variant="outlined"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{ minWidth: 120 }}
        >
          <MenuItem value="all">All Levels</MenuItem>
          <MenuItem value="info">Info</MenuItem>
          <MenuItem value="warn">Warn</MenuItem>
          <MenuItem value="error">Error</MenuItem>
          <MenuItem value="debug">Debug</MenuItem>
        </TextField>
      </Box>
      <div ref={scrollRef} className={classes.logViewer}>
        {filteredLogs.length === 0 && <span style={{ color: '#9CA3AF' }}>No logs to display</span>}
        {filteredLogs.map((log, i) => (
          <div key={i}>
            <span style={{ color: '#6B7280' }}>{formatTimestamp(log.timestamp)}</span>
            {' '}
            <span className={getLevelClass(log.level)}>
              [{log.level.toUpperCase()}]
            </span>
            {' '}
            <span style={{ color: '#F9FAFB', fontWeight: 600 }}>[{log.action}]</span>
            {log.user && <span style={{ color: '#A78BFA' }}> ({log.user})</span>}
            {log.details && <span> {log.details}</span>}
          </div>
        ))}
      </div>
    </Box>
  );
};

export default TestLogViewer;
